import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  static targets = ['templateBody', 'templateSubject']

  declare templateBodyTarget: HTMLElement
  declare templateSubjectTarget: HTMLElement

  copyTemplate (): void {
    const body = document.querySelector('lexxy-editor[name$="[body]"]') as LexxyEditor
    const submitButton = document.querySelector('input[type=submit]') as HTMLInputElement
    body.value = `${this.templateBodyTarget.innerHTML}${body.value}`

    const subject = document.querySelector('lexxy-editor[name$="[subject]"]') as LexxyEditor
    subject.value = `${this.templateSubjectTarget.innerText} ${this.plainText(subject.value)}`

    submitButton.disabled = false
  }

  private plainText (html: string): string {
    return new DOMParser().parseFromString(html, 'text/html').body.textContent ?? ''
  }
}
